import React, { memo, useEffect, useRef } from "react"
import PropTypes from "prop-types"

const CSlider = ({
  children,
  lang,
  path,
  sliderClasses,
  lastArrowBlack,
  collapseOnMobile,
  loadLastSlideItemHalfway,
  activeSlideIndex,
  radioButtonIdOffset,
  touchScrollable,
  slides,
  sliderTheme,
  intervalTimeoutDuration,
  stopFirstAndLastSlideTransitions,
  intervalExternalFunction,
  dynamicIntervalTimeoutArray,
  prevLabelFunc,
  nextLabelFunc,
}) => {
  const sliderRef = useRef(null)

  useEffect(() => {
    if (activeSlideIndex) {
      sliderRef.current.activeSlideIndex = activeSlideIndex
    }
    if (sliderTheme) {
      sliderRef.current.theme = sliderTheme
    }
  }, [activeSlideIndex, sliderTheme])

  useEffect(() => {
    sliderRef.current.lastArrowBlack = lastArrowBlack
    sliderRef.current.collapseOnMobile = collapseOnMobile
    sliderRef.current.loadLastSlideItemHalfway = loadLastSlideItemHalfway
    if (sliderClasses) {
      sliderRef.current.className = sliderClasses
    }
    if (radioButtonIdOffset) {
      sliderRef.current.radioButtonIdOffset = radioButtonIdOffset
    }
    if (intervalTimeoutDuration) {
      sliderRef.current.intervalTimeoutDuration = intervalTimeoutDuration
    }
    if (stopFirstAndLastSlideTransitions) {
      sliderRef.current.stopFirstAndLastSlideTransitions = stopFirstAndLastSlideTransitions
    }
    if (intervalExternalFunction) {
      sliderRef.current.intervalExternalFunction = intervalExternalFunction
    }
    if (dynamicIntervalTimeoutArray) {
      sliderRef.current.dynamicIntervalTimeoutArray = dynamicIntervalTimeoutArray
    }
    if (prevLabelFunc) {
      sliderRef.current.prevLabelFunc = prevLabelFunc
    }
    if (nextLabelFunc) {
      sliderRef.current.nextLabelFunc = nextLabelFunc
    }
    if (touchScrollable) {
      sliderRef.current.touchScrollable = touchScrollable
    }
  }, [])

  return (
    <c-slider path={path} slides={slides} slider-lang={lang} ref={sliderRef}>
      {children}
    </c-slider>
  )
}

CSlider.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.string,
  path: PropTypes.string,
  slides: PropTypes.number,
  sliderClasses: PropTypes.string,
  lastArrowBlack: PropTypes.bool,
  collapseOnMobile: PropTypes.bool,
  loadLastSlideItemHalfway: PropTypes.bool,
  activeSlideIndex: PropTypes.number,
  radioButtonIdOffset: PropTypes.number,
  sliderTheme: PropTypes.bool,
  intervalTimeoutDuration: PropTypes.number,
  stopFirstAndLastSlideTransitions: PropTypes.bool,
  intervalExternalFunction: PropTypes.func,
  dynamicIntervalTimeoutArray: PropTypes.array,
  touchScrollable: PropTypes.bool,
  nextLabelFunc: PropTypes.func,
  prevLabelFunc: PropTypes.func,
}

export default memo(CSlider)
